import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class TableSortService {


  getSortedData(sort: any, refTable: any) {
    if (sort.key && sort.value) {
    refTable = refTable.sort((a: any, b: any) => {
      let aVal = a[sort.key!];
      let bVal = b[sort.key!];
      
      if (sort.key === 'updatedDate' || sort.key === 'createdDate' || sort.key === 'actionOnDate' || sort.key === 'actionOn' || sort.key === 'aeoCertificateValidityPeriodTo') {
        aVal = aVal ? new Date(aVal).getTime() : 0;
        bVal = bVal ? new Date(bVal).getTime() : 0;
      }
      
      if (sort.key === 'version') {
        aVal = parseFloat(aVal) || 0;
        bVal = parseFloat(bVal) || 0;
      }
      return sort.value === 'ascend' ? aVal > bVal ? 1 : -1 : bVal > aVal ? 1 : -1;
    });

    return refTable;
  } else {
    return refTable;
  }
}

}
